import React, { useState, useEffect } from "react";

const OrganizationsPage = () => {
    const [showEditPage, setShowEditPage] = useState(false);
    const [tempOrganizationData, setTempOrganizationData] = useState('');
    const [organizationData, setOrganizationData] = useState('');
    const [loading, setLoading] = useState(true);

    const fetchOrganizationData = async () => {
        try {
            const response = await fetch('https://meetmind.ru/v1/spec/profile/get-organization');
            if (response.ok) {
                const data = await response.json();
                setOrganizationData(data.organization_and_position);
            } else {
                console.error('Failed to fetch organization_and_position data');
            }
        } catch (error) {
            console.error('Error fetching organization_and_position data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganizationData();
    }, []);

    const handleEditPage = (e) => {
        e.preventDefault();
        if (showEditPage) {
            setTempOrganizationData('');
        } else {
            setTempOrganizationData(organizationData);
        }
        setShowEditPage(!showEditPage);
    };

    const sanitizeTextInput = (e) => {
        const value = e.target.value.replace(/[<>"'&]/g, '');
        setTempOrganizationData(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://meetmind.ru/v1/spec/profile/set-organization', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ "organization_and_position": tempOrganizationData }),
                credentials: 'include',
            });

            if (response.ok) {
                console.log('Data saved successfully');

                fetchOrganizationData();

                setShowEditPage(false);
            } else {
                console.error('Failed to save organization_and_position data');
            }
        } catch (error) {
            console.error('Error saving organization_and_position data:', error);
        }
    };

    return (
        <div className="profile">
            {!showEditPage ? (
                <div className="profile__body">
                    <div className="profile__header">
                        <div className="profile__title">Организации</div>
                        <div className="profile__controller" onClick={handleEditPage}>
                            <i className="fa-solid fa-pen-to-square"></i>
                        </div>
                    </div>
                    <div className="profile__content">
                        <div className="profile__field">
                            <label className="profile__label label">
                                Организации, в которых Вы состоите, и Ваш статус
                                <textarea className="profile__textarea textarea" rows="5" disabled value={organizationData}></textarea>
                            </label>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="profile__body">
                    <div className="profile__header">
                        <div className="profile__title">Организации</div>
                        <div className="profile__controller" onClick={handleEditPage}>
                            <i className="fa-solid fa-xmark"></i>
                        </div>
                    </div>
                    <div className="profile__content">
                        <div className="profile__field">
                            <label className="profile__label label">
                                Организации, в которых Вы состоите, и Ваш статус
                                <textarea
                                    className="profile__textarea textarea"
                                    rows="5"
                                    value={tempOrganizationData}
                                    onChange={sanitizeTextInput}
                                    maxLength={450}
                                ></textarea>
                            </label>
                        </div>
                    </div>
                    <div className="profile__actions">
                        <button className="profile__button button" onClick={handleSubmit}>Сохранить изменения</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default OrganizationsPage;
